<template>
  <div class="live-list">
    <div class="live-show">
      <div class="live-list-content">
        <div class="img-show" :style="'background-image: url('+liveSelect.image+')'" @click="getChannelNo">
          <!-- <img :src="liveList[0].image" alt=""> -->
          <!-- <img :src="liveSelect.image"> -->
          <div class="no_live" v-if="liveModule.length<=0">
            <img src="@/assets/live_icon.png" alt="">
            <span>暂无直播</span>
          </div>
        </div>
        <ul class="live-list">
          <li class="live-info" :class="item.id==liveSelect.id? 'active': ''" v-for="item in liveModule" :key="item.id" @click="selectLive(item)">
            <div :class="item.liveNow? 'live-now': 'live-date'">
              {{item.liveNow? '正在直播': item.live_date}}
              <span class="live-end-label" v-if="Date.now()/1000 > item.end_time">已结束</span>
            </div>
            <div class="live-title" @click="liveModuleImg=item.image">
             <!-- <router-link  :to="'/live/'+item.channel_no">{{item.name}}</router-link> -->
              {{item.name}}
              </div>
            <div class="live-lecturer">主讲人：{{item.teacher_name}}</div>
            <router-link 
              v-if="item.liveNow && Date.now()/1000 <= item.end_time" 
              :to="'/live/'+item.channel_no+'/'+item.id" 
              class="enter-live"
            >进入直播</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="live-list-box">
      <div class="live-content">
        <div class="title">查看回放</div>
        <ul class="list">
          <li class="info" v-for="item in courseList.data" :key="item.id">
            <img class="info-img" v-lazy="item.image" :key="item.image">
            <div class="info-content">
              <div class="info-title">{{item.name}}</div>
              <div class="info-describe">{{item.intro}}</div>
              <div class="info-date">{{item.created_at}}</div>
            </div>
            <div class="ope">
              <router-link class="show-playback" :to="'/recordedInfo/' + item.id">查看回放</router-link>
              <!-- <div class="statistics">34564已查看</div> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'liveList',
  data(){
    return {
      liveModule: '',  //直播列表
      courseList: '',  //回放
      liveSelect: ''
    }
  },
  mounted(){
    this.getLiveList();  //获取直播列表
    this.getCourseList();//获取回放
  },
  methods: {
     getChannelNo(){
      // 通过end_time 判断当前直播是否结束 结束提示"当前直播已结束 end_time: 1749713400"
      let nowTime = Date.now() / 1000;
      if(nowTime > this.liveSelect.end_time) {
        this.$message({
          message: '当前直播已结束',
          type: 'warning'
        });
        return;
      }
      this.$router.push('/live/'+this.liveSelect.channel_no+'/'+this.liveSelect.id)
    },
    //获取直播列表
    getLiveList(){
      this.$axios.post(`/v1/live/list`).then(res => {
        let nowDta = Date.now() / 1000;
        for(let i=0; i<res.data.length; i++){
          if(nowDta>res.data[i].live_time && nowDta<res.data[i].end_time){
            res.data[i].liveNow = true;
          }else{
            res.data[i].liveNow = false;
          }
        }

        this.liveModule = res.data;
        this.liveSelect = res.data[0];
      })
    },
    //获取回放
    getCourseList(){
      this.$axios.post(`/v1/live/courseList`).then(res => {
        this.courseList = res.data;
      })
    },
    selectLive(data){
      this.liveSelect = data;
    },
  }
}
</script>
<style scoped lang="scss">
.live-show{
  box-sizing: border-box;
  width: 100%;
  height: 624px;
  padding-top: 59px;
  background: url(~@/assets/top-bg.png) no-repeat center center;
  background-size:auto 100%;
}
.live-list-content{
  width: 1200px;
  height: 506px;
  margin: 0 auto;
  .img-show{
    width: 800px;
    height: 506px;
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center center;
    // img{
    //   width: auto;
    //   height: 100%;
    // }
  }
  .live-list{
    width: 400px;
    height: 506px;
    background-color: #2B334D;
  }
  .live-info{
    cursor: pointer;
    &::after{
      background-color: rgba(255, 255, 255, 0.04);
      bottom: 4px;
    }
    &.active{
      background-color: #101832;
    }
  }
  .live-title {
    color: #FFF;
    margin-bottom: 24px;
    a{
      color: #fff;
    }
  }
  .live-lecturer,
  .live-date{
    color: #D8D8D8;
  }
  .live-date{
    background: url(~@/assets/clock2-ico.png) no-repeat;
    background-size: 20px;
    background-position: 6px center;
    font-size: 14px;
    .live-end-label {
      font-size: 12px;
      color: #999;
      margin-left: 8px;
    }
  }
}
.live-list-box{
  width: 100%;
  background-color: #F7F7F7;
  padding: 34px 0 88px;
}
.live-content{
  width: 1200px;
  margin: 0 auto;
  padding: 34px 24px 40px;
  background-color: #fff;
  .title{
    font-size: 24px;
    font-weight: 800;
    color: #333;
    margin-bottom: 24px;
  }
  .info{
    box-sizing: border-box;
    width: 100%;
    padding: 10px 30px 10px 10px;
    margin-bottom: 4px;
    position: relative;
    overflow: hidden;
    &:hover{
      box-shadow: 0px 0px 14px 0px rgba(0, 12, 40, 0.14);
    }
  }
  .info-img{
    width: 282px;
    height: 156px;
    box-shadow: 0px 0px 14px 0px rgba(0, 12, 40, 0.14);
    border-radius: 8px;
    float: left;
  }
  .info-content{
    width: 578px;
    float: left;
    margin-left: 24px;
  }
  .info-title{
    font-size: 16px;
    font-weight: 800;
    color: #333;
    line-height: 28px;
    text-shadow: 0px 0px 14px rgba(0, 12, 40, 0.14);
    margin-bottom: 10px;
  }
  .info-describe{
    font-size: 14px;
    color: #999;
    height: 48px;
    line-height: 24px;
    text-shadow: 0px 0px 14px rgba(0, 12, 40, 0.14);
    //多行省略号
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-bottom: 34px;
  }
  .info-date{
    font-size: 12px;
    font-weight: 500;
    color: #999;
    line-height: 17px;
    text-shadow: 0px 0px 14px rgba(0, 12, 40, 0.14);
  }
  .ope{
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 30px;
  }
  .show-playback{
    box-sizing: border-box;
    width: 114px;
    height: 40px;
    line-height: 40px;
    padding-left: 38px;
    background: url(~@/assets/video-ico.png) no-repeat #FFC30B -2px center;
    background-size: 48px;
    box-shadow: 0px 0px 14px 0px rgba(0, 12, 40, 0.14), 0px 0px 8px 0px rgba(86, 63, 25, 0.14);
    border-radius: 6px;
    font-size: 16px;
    color: #FFF;
    text-shadow: 0px 0px 14px rgba(0, 12, 40, 0.14);
    text-align: left;
    margin-bottom: 8px;
    cursor: pointer;
  }
  .statistics{
    font-size: 12px;
    font-weight: 900;
    color: #999;
    line-height: 17px;
    text-shadow: 0px 0px 14px rgba(0, 12, 40, 0.14);
    text-align: center;
  }
}
.live-btn{
  text-align: center;
  line-height: 34px;
}

// 直播提示
.no_live{
  width: 50%;
  height: 50%;
  background: rgba(255,255,255,.3);
  border-radius: 10px;
  margin: 15% auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 50px;
    height: 50px;
  }
  span{
    font-size: 30px;
    margin-left: 20px;
  }
}

.enter-live {
  display: inline-block;
  padding: 6px 16px;
  background: #3164F6;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  &.end {
    background: #f5f5f5;
    color: #999;
    cursor: default;
  }
}
</style>